export default "__VITE_ASSET__Cq74yJNc__"